<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="店铺名称" v-if="stoId==0" class='tiny'>
						<el-input style="width:180px;" v-model="orderInfo.storeName" placeholder="请输入店铺名称">
						</el-input>
					</el-form-item>
					<el-form-item label="卡项名称" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.cardName" placeholder="请输入卡项名称">
						</el-input>
					</el-form-item>
					<el-form-item label="卡项类别" class='tiny'>
						<el-select v-model="orderInfo.cardType"  style="width:120px;">
							<el-option key="-1" label="全部" value="">全部</el-option>	
							<el-option  key="1" :value="1" label="会员卡">会员卡</el-option>
							<el-option key="2" :value="2"	 label="次卡">次卡</el-option>
							<el-option key="3" :value="3" label="包年包月卡">包年包月卡</el-option>
						</el-select>
					</el-form-item>
					
					
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="orderInfo.status"  style="width:120px;">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option value="true" label="启用">启用</el-option>
							<el-option value="false" label="停用">停用</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否默认卡项" class='tiny' >
						<el-select v-model="orderInfo.isDefault"  style="width:120px;">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option value="true" label="是">是</el-option>
							<el-option value="false" label="否">否</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="是否可以多张" class='tiny'>
						<el-select v-model="orderInfo.isRepeat">
							<el-option value="true" label="是">是</el-option>
							<el-option value="false" label="否">否</el-option>
						</el-select>
					</el-form-item> -->
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button v-if="stoId!=0" type="primary" @click="editialogVisible()">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%" >
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="卡项名称">
							<span>{{ props.row.cardName }}</span>
						</el-form-item>
						<el-form-item label="卡项图片">
							<!-- <span>{{ props.row.cardName }}</span> -->
							<el-button size="small" type="text" @click="dialogImageUrl=props.row.backImages;dialogVisibleImg=true;">查看</el-button>
						</el-form-item>
						<el-form-item label="单价(元)">
							<span>{{props.row.price?props.row.price:'免费'}}</span>
						</el-form-item>
						<el-form-item label="是否限制次数" v-if="props.row.cardType!=2">
							<span>{{props.row.isCardTimes?'是':'否'}}</span>
						</el-form-item>
						<el-form-item label="卡项使用次数" v-if="props.row.isCardTimes&&props.row.cardType==3">
							<span>{{props.row.cardTimes}}</span>
						</el-form-item>
						<el-form-item label="卡项使用次数" v-if="props.row.cardType==2" >
							<span>{{props.row.cardTimes}}</span>
						</el-form-item>
						<el-form-item label="是否默认卡项">
							<span>{{props.row.isDefault?'是':'否'}}</span>
						</el-form-item>
						<!-- <el-form-item label="是否可以多张">
							<span>{{ props.row.isRepeat==1?'是':'否' }}</span>
						</el-form-item> -->
						<el-form-item label="是否赠送积分">
							<span>{{ props.row.isRewardIntegral==1?'是':'否' }}</span>
						</el-form-item>
						<el-form-item  v-if="props.row.isRewardIntegral==1" label="赠送积分">
							<span>赠送{{ props.row.rewardIntegralNum }}{{ props.row.integralName }}</span>
						</el-form-item>
						<el-form-item label="卡项说明">
							<span v-if="props.row.cardInformation">{{props.row.cardInformation}}</span>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="创建时间">
							<span>{{props.row.createDate}}</span>
						</el-form-item>
						<el-form-item label="更新时间">
							<span>{{props.row.updateDate}}</span>
						</el-form-item>
						
					</el-form>
				</template>
			</el-table-column>
			
			<el-table-column prop="storeName" v-if="stoId==0"  label="店铺名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="cardName" label="卡项名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="cardType" label="卡项类别" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.cardType==1">会员卡</span>
					<span v-if="scope.row.cardType==2">次卡</span>
					<span v-if="scope.row.cardType==3">包年包月卡</span>
					
				</template>
			</el-table-column>
			
			<el-table-column prop="discount" label="卡项折扣" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.discount?scope.row.discount:'无折扣'}}
				</template>
			</el-table-column>
			<el-table-column prop="price" label="单价(元)" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{scope.row.price?scope.row.price:'免费'}}</span>
				</template>
		
			</el-table-column>
			<el-table-column prop="validityDay" label="有效期(天)" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.validityDay==0?'永久有效':scope.row.validityDay}}
				
				</template>
			</el-table-column>
			
			<el-table-column prop="orderIndex" label="排序" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==true">启用</span>
					<span v-if="scope.row.status==false">停用</span>
				</template>
			</el-table-column>
			<el-table-column prop="cardTimes" label="使用次数" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.cardTimes?scope.row.cardTimes:'--'}}
				</template>
			</el-table-column>
			<el-table-column prop="isRepeat" label="核销设置" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button v-if="scope.row.price>0" @click="sethx(scope.row)">核销设置</el-button>
					<span v-else>--</span>
				</template>
			</el-table-column>
		
			<el-table-column prop=""   label="操作"  fixed="right" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<el-button  size="small" v-if="!scope.row.status" type="text" @click="glstatus(scope.row.id,1)">启用</el-button>　
					<el-button style="color: red;" size="small" v-else type="text" @click="glstatus(scope.row.id,2)">停用</el-button>　
					
				</template>
			</el-table-column>
		</el-table> 
		<!-- 分页 -->
		<el-pagination style="margin: 20px;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title" @close="addDialogClose" 
			:close-on-click-modal="false">
			<div style="text-align: center;overflow-y: scroll;height: 70vh;">
				<el-form v-model="storeGoodsInfo">
					
					<div style="display: flex;justify-content: space-between;">

						<el-form-item label="卡项类别">
							<el-select v-model="storeGoodsInfo.cardType" style="width: 200px;"
							@change="cardTypeChange">
								<el-option key="1" :value="1" label="会员卡-会员免费开卡">会员卡-会员免费开卡</el-option>
								<el-option key="2" :value="2"	 label="次卡">次卡</el-option>
								<el-option key="3" :value="3" label="包年包月卡">包年包月卡</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="店铺名称" v-if="title=='编辑卡项'&&stoId==0">
							<el-input disabled type="text" style="width: 200px; margin-left:25px ;" v-model="storeGoodsInfo.storeName"
								auto-complete="off" placeholder="请输入店铺名称" />
						</el-form-item>

					</div>
					<div style="display: flex;justify-content: space-between;">
						<el-form-item label="卡项名称" style="margin-right: 80px;">
							<el-input type="text" style="width: 200px;" v-model="storeGoodsInfo.cardName"
								auto-complete="off" placeholder="请输入卡项名称" />
						</el-form-item>
					</div>
					<div style="display: flex;justify-content: space-between;">
						<el-form-item label="单价  (元)">
							<el-input :disabled="checked1" type="text" style="width: 200px;" v-model="storeGoodsInfo.price"
								auto-complete="off" placeholder="请输入单价(为0时免费)" />
								<div style="margin-left: 20px;">
									  <el-checkbox v-model="checked1">免费</el-checkbox>
								</div>
						</el-form-item>
						<el-form-item label="有效时长(天)" style="display: flex;margin-right:20px;">
							 
							<el-input :disabled="checked" type="number" style="width: 200px;" v-model="storeGoodsInfo.validityDay"
								auto-complete="off" placeholder="请输入有效时长(设置0为无限期)" />
								<div style="margin-left: 20px;">
									<el-checkbox v-model="checked">无限期</el-checkbox>
								</div>
						</el-form-item>
					</div>
					
					<div style="margin-bottom: 30px;">
						<el-form-item label="卡项图片">
								<el-upload class="upload-demo" :action="imgUrl" :on-preview="handlePreview"
								:show-file-list="false" :on-success="onSuccess" :on-remove="handleRemove"
									:before-remove="beforeRemove" multiple :limit="100" :on-exceed="handleExceed"
									:file-list="fileList">
									<el-button size="small" type="primary">卡项背景 建议尺寸 750 * 450 px 点击更换</el-button>
									<!-- <div slot="tip" class="el-upload__tip">卡项背景 建议尺寸 750 *450 px </div> -->
								</el-upload>
								
						</el-form-item>
						<div style="display: flex;justify-content: flex-start;">
							<img v-if="bgImg" :src="bgImg" width="600px" height="360px" />
							<div v-else>
								<!-- 请上传图片 -->
								<img  src="../../assets/images/card_bg.png" width="600px" height="360px" />
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: space-between;">
						<el-form-item v-if="storeGoodsInfo.cardType==1" label="卡项折扣(例0.88为88折)" style="margin-right: 80px;">
							<el-input type="text" style="width: 200px;" v-model="storeGoodsInfo.discount"
								auto-complete="off" placeholder="请输入卡项折扣(例0.88为88折)" />
						</el-form-item>

						<el-form-item v-if="storeGoodsInfo.cardType==3" label="是否限制次数" class="redItem">
							<el-switch v-model="storeGoodsInfo.isCardTimes" :active-value="true" :inactive-value="false"
								class="switchss">
							</el-switch>
						</el-form-item>
						
						<el-form-item label="使用次数" v-if="storeGoodsInfo.cardType==2">
							<el-input type="text" style="width: 225px;" v-model="storeGoodsInfo.cardTimes"
								auto-complete="off" placeholder="请输入使用次数" />
						</el-form-item>
						<el-form-item label="使用次数" v-if="storeGoodsInfo.cardType==3&&storeGoodsInfo.isCardTimes">
							<el-input type="text" style="width: 225px;" v-model="storeGoodsInfo.cardTimes"
								auto-complete="off" placeholder="请输入使用次数" />
						</el-form-item>
					</div>
					
					<div style="display: flex;justify-content: space-between;">
						<el-form-item label="排 序" >
							<el-input type="text" style="width: 200px;margin-left: 25px; " v-model="storeGoodsInfo.orderIndex"
								auto-complete="off" placeholder="请输入排序号" />&nbsp;<span id="">
									  (数值越大，排序越靠前)
								</span>
						</el-form-item>
					</div>
					<el-form-item label="是否默认开卡项" class="redItem">
						<el-switch v-model="storeGoodsInfo.isDefault" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<div style="display: flex;justify-content: space-between;">
						<el-form-item label="是否赠送积分" class="redItem">
							<el-switch v-model="storeGoodsInfo.isRewardIntegral" :active-value="true" :inactive-value="false"
								class="switchss">
							</el-switch>
						</el-form-item>
						<el-form-item label="选择积分" class="redItem" v-if="storeGoodsInfo.isRewardIntegral">
							<el-select v-model="storeGoodsInfo.rewardIntegralId">
									
							<el-option v-for="item in IntegralList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
								
							</el-select>
						</el-form-item>
						<el-form-item label="赠送数量" v-if="storeGoodsInfo.isRewardIntegral" class="redItem">
							<el-input type="text" style="width: 225px;" v-model="storeGoodsInfo.rewardIntegralNum"
								auto-complete="off" placeholder="请输入赠送数量" />
						</el-form-item>
					</div>
					<div>
						<el-form-item label="说明" class="redItem">
							<el-input type="textarea" style="width: 500px;" v-model="storeGoodsInfo.cardInformation"
								auto-complete="off" placeholder="请输入卡项说明" />
						</el-form-item>
					</div>
					
					<el-button type="primary" v-if="title=='新增卡项'" @click="sure" style="margin-top: 100px;"
					:loading="sureLoading">提交</el-button>
					<el-button type="primary" v-else @click="submit" style="margin-top: 100px;"
					:loading="submitLoading">编辑</el-button>
				</el-form>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="hxdialogVisible" title="核销设置" @close="hxdialogVisible=false"
			:close-on-click-modal="false" >
			<div style="height: 500px;overflow-y: scroll;">
					
						<div style="display: flex;align-items: center;">
							是否开启分成 <el-switch v-model="info.isOpenShar" :active-value="true" :inactive-value="false" style="margin-left: 10px;">
							</el-switch> 
						</div>
				
					
				<el-table :data="inputLists" style="width: 100%" ref="multipleTable" v-if="info.isOpenShar"
					@selection-change="handleSelectionChange">
					
					<el-table-column prop="name" label="岗位" width="150">
					
					</el-table-column>
					<el-table-column prop="jobLevelRewardListDots" label="级别">
						<template slot-scope="scope" >
							<el-table  v-if="scope.row.jobLevelRewardListDots.length>0" :data="scope.row.jobLevelRewardListDots" style="width: 100%" >
								<el-table-column prop="name" label="级别名称" >
								</el-table-column>
								<el-table-column prop="name" label="岗位分成比例(%)">
									
									<template slot-scope="scope">
										<div style="display: flex;align-items: center;"  >
												<el-input v-model="scope.row.rewardRate" style="width: 80px;" size="mini" placeholder="输入岗位分成比例(%)" type="text"
													@input="inputs(scope)" />
												<span style="padding-left: 10px;">%</span>
										</div>
										
									</template>
								</el-table-column>
								<el-table-column prop="rewardNum" label="岗位分成金额" >
									<template slot-scope="scope">
										<el-input v-model="scope.row.rewardNum"  size="mini" placeholder="输入岗位分成金额" type="text"
											 />
									</template>
								</el-table-column>
							</el-table>	
							<span v-else>暂无级别</span>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="岗位分成比例(%)" width="200"  >
						<template slot-scope="scope">
							<div style="display: flex;align-items: center;"  v-if="scope.row.jobLevelRewardListDots.length==0">
									<el-input v-model="scope.row.rewardRate" @input="inputs(scope)" size="mini" placeholder="输入岗位分成比例(%)" type="text"
									oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 80px;" />
									<span style="padding-left: 10px;">%</span>
							</div>
								
						</template>
					</el-table-column>
					<el-table-column prop="rewardNum" label="岗位分成金额"  width="200">
						<template slot-scope="scope">
							<el-input v-if="scope.row.jobLevelRewardListDots.length==0" v-model="scope.row.rewardNum"  size="mini" placeholder="输入岗位分成金额" type="text"
								 />
						</template>
					</el-table-column>
				
				</el-table>
				
			</div>
			<div>
				<el-button type="primary" @click="sures" style="margin-top: 50px;" :loading="suresLoading">提交</el-button>
			</div>
		</el-dialog>
		<!-- 编辑修改 -->


		<!-- 图片查看 -->
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false" title="卡项图片查看">
			<div style="text-align: center;">
				<img v-if="dialogImageUrl" :src="dialogImageUrl"  width="750px" height="450px">

				<img v-else src="../../assets/images/card_bg.png" width="750px" height="450px" />
			</div>
			<div style="text-align: center;margin-top:40px">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('card');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				imgUrl: urls,
				checkList:[],
				hxdialogVisible:false,
				inputLists:[],
				stoId:'',
				checked1:false,
				checked:false,
				price:'',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				tableData:[
					{
						levelName:'',
						orderIndex:'',
						status:false
					}
				],
				sliderlist:{},
				expressList: [],
				orderInfo: {
					cardType: '',
					status: '',
					isDefault: '',
				},
				storeGoodsInfo: {
					isRewardIntegral:false,
					isRepeat:false,
					isDefault:false,
					isCardTimes:false
				},
				dialogVisibleSwiper: false,
				cardId:'',
				dialogVisibleSwipers: false,
				title:'',
				IntegralList:[],
				dialogImageUrl:'',
				httpUrl: urls,
				httpUrl1: urls,
				fileList: [],
				fileList1: [],
				info:{},
				goodsList:[],
				goodsImages:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},

				bgImg: '',

				dialogVisibleImg: false,

				submitLoading: false,
				sureLoading: false,
				suresLoading: false,
			}
		},
		watch: {
			checked(newValue, oldValue) {
				if(newValue){
					this.storeGoodsInfo.validityDay=0
				}
			},
			checked1(newValue, oldValue) {
				if(newValue){
					this.storeGoodsInfo.price=0
				}
			},
		},
		activated() {
			
		},
		methods: {
			cardTypeChange(e){
				console.log('111--', e)
				if(e == 1){
					this.checked1 = true
				}
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.bgImg = response.message;
			},

			selectable(){
				
			},
			sures(){
				this.suresLoading = true;
				this.$set(this.inputLists[0],'cardId',this.cardId)
				this.$set(this.inputLists[0],'type',1)
				this.$set(this.inputLists[0],'isOpenShar',this.info.isOpenShar)
				this.inputLists.map(item=>item.rewardRate=item.rewardRate/100)
				this.inputLists.map(item=>{
					item.jobLevelRewardListDots.map(item=>item.rewardRate=item.rewardRate/100)
				})
				this.$api.adderpCardJobRewards(this.inputLists).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.hxdialogVisible=false
						this.suresLoading = false;
						this.pmsbrdselect();
					} else {
						this.$message.error(res.message);
						this.suresLoading = false;
					}
				})
				// console.log(this.inputLists);
			},
			inputs(a){
				if(this.info.cardType==2){
					a.row.rewardNum = (a.row.rewardRate * (this.price/this.info.cardTimes)*10000000/1000000000).toFixed(2)
				}
				else{
					a.row.rewardNum = (a.row.rewardRate * this.price*10000000/1000000000).toFixed(2)
				}
				
			},
			
			handleSelectionChange(e){
				console.log(e);
			},
			sethx(row){
				this.price=row.price
				this.cardId=row.id
				this.info=row
				this.$api.getJobList({storeId:row.storeId,cardId:this.cardId,type:1}).then(res=>{
					console.log(res);
					this.inputLists=res.data
					this.inputLists.map(item=>item.rewardRate=item.rewardRate*100)
					this.inputLists.map(item=>{
						item.jobLevelRewardListDots.map(item=>item.rewardRate=item.rewardRate*100)
					})
				})
				this.hxdialogVisible=true
			},
			sure(){
				this.sureLoading = true;
				let data = {
					...this.storeGoodsInfo,
					backImages: this.bgImg
				}
				this.$api.adderpCard(data).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {
							isRewardIntegral:false,
							isRepeat:false,
							isCardTimes:false,
							isDefault:false,}
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})
			},
			del(it){
				this.tableData.splice(it,1)
				
			},
			add(){
				this.tableData.push({
					levelName:'',
					orderIndex:'',
					status:false
				})
			},
			addDialogClose(){
				this.dialogVisibleSwiper=false
			},
		
			search() { //查询
					
				this.pmsbrdselect()

			},
			empty() { //清空
				this.orderInfo = {}
				this.page.pageNum=1
			},
			
			pmsbrdselect() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					...this.orderInfo
				}
				this.$api.finderpCard(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
		

			// 提交
			submit() {
				this.submitLoading = true;
				let data = {
					...this.storeGoodsInfo,
					backImages: this.bgImg
				}
				// console.log(data)
				this.$api.editerpCard(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {
							isRewardIntegral:false,
							isRepeat:false,
							isDefault:false,
							isCardTimes:false,
						}
					} else {
						this.$message.error(res.message);
					}
					this.submitLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
				this.dialogVisibleSwiper=true
				this.bgImg = '';
				this.checked1 = false;
				this.checked = false;
				if(e){
					
					this.title='编辑卡项'
					this.$api.findByIdCard(e).then((res) => {
						if (res.state == 'success') {
							
							this.storeGoodsInfo = res.data

							this.bgImg = res.data.backImages

							if(this.storeGoodsInfo.price>0){
								this.checked=false
							}else{
								this.checked=true
							}
							if(this.storeGoodsInfo.validityDay>0){
								this.checked1=false
							}else{
								this.checked1=true
							}
							this.dialogVisibleSwipers = true
					
						}
					})
				}else{
					this.title='新增卡项'
					this.storeGoodsInfo = {
						isRewardIntegral:false,
						isRepeat:false,
						isDefault:false,
						isCardTimes:false
					}
					
				}
				
				
			
				
			},
			glstatus(e,type){
				if(type==2){
					var str = "此操作将停用该卡项, 是否继续?"
				}else{
					var str = "此操作将启用该卡项, 是否继续?"
				}
				
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.statuserpCard(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			
			// 删除
			toDelete(e) {
				console.log(e)
				var str = "此操作将删除该卡项, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.delerpCard(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.pmsbrdselect();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pmsbrdselect()
			},
		},




		created() {
			this.pmsbrdselect()
			this.$api.getUserInfo(this.$encrypt({})).then(res => {
				res.data = JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					// console.log('登录人信息---', res.data )
					// supplierId(有值就是供应商)
					this.stoId = res.data.storeId; // storeId：0(平台)   
					
				}
			})
			this.$api.integralList({isCardReward:1}).then(res=>{
				// console.log(res);
				this.IntegralList=res.data
			})

			// this.$api.findxxGoodsList({}).then(res=>{
			
			// 	this.goodsList=res.data
			// })
		}
	}
</script>

<style scoped lang="less">
	/deep/.el-dialog{
		width: 70vw !important;
		height: 85vh;
		margin-top: 50px !important;
	}
</style>
